export interface AlertOptions {
    title: string;
    message: string;
    visible: boolean;
    code: string;
    type?: 'error' | 'warning' | 'success';
    time?: unknown;
    actions?: unknown;
    posture?: unknown;
}

export const PositivePayOptions = {
    allowIssuedItemActivityReview: 'PositivePay.AllowIssuedItemActivityReview',
    showAchExceptions: 'PositivePay.ShowAchExceptions',
    workAchExceptions: 'PositivePay.WorkAchExceptions',
    workCheckExceptions: 'PositivePay.WorkCheckExceptions',
    achFilterManagement: {
        allowManageAchFilters: 'PositivePay.ACHFilterManagement.AllowManageAchFilters',
        approversRequired: 'PositivePay.ACHFilterManagement.ApproversRequired',
    },
    checkExceptions: {
        allowReturnReason: 'PositivePay.CheckException.AllowReturnReason',
        allowCorrectionRequest: 'PositivePay.CheckException.AllowCorrectionRequest',
    },
    substituteProductConfig: {
        allowSubstituteProduct: 'PositivePay.SubstituteProductConfig.AllowSubstituteProduct',
    },
};
